/**
 * Hero / event summary: title + subtitle on top; date card left, badge rows right.
 */
export default function EventHeader({
  weekdayShort = "SAT",
  dayNumber = "30",
  monthShort = "MAY",
  year = "2026",
  title = "UXデザインプロセスをわかりやすく解説 — プロのようにカスタマイズする正しい方法！",
  subtitle = "オンラインクラス（ライブQ&A付き）",
  metaBadges = [
    { variant: "solid-green", text: "高田馬場" },
    { variant: "solid-cyan", text: "14:00–16:00" },
    { variant: "outline-cyan", text: "1,200円" },
    { variant: "muted", text: "24名/先着" },
    { variant: "muted", text: "初心者向け" },
  ],
  topicBadges = [
    "UXデザイン",
    "UXデザイン",
    "UXデザイン",
    "FIGMA",
    "カスタマイズ",
    "問題解決",
    "デザインプロセス",
    "デザインプロセス",
  ],
} = {}) {
  return (
    <section className="event-temp-event-header" aria-labelledby="event-temp-event-title">
      <div className="event-temp-event-header__intro">
        <h1 id="event-temp-event-title" className="event-temp-event-header__title">
          {title}
        </h1>
        <p className="event-temp-event-header__subtitle">{subtitle}</p>
      </div>

      <div className="event-temp-event-header__detail">
        <div className="event-temp-event-header__date-card">
          <span className="event-temp-event-header__weekday">{monthShort}</span>
          <span className="event-temp-event-header__day">{dayNumber}</span>
          <span className="event-temp-event-header__month-year">
            <span className="event-temp-event-header__month">{weekdayShort}</span>
            <span className="event-temp-event-header__year">{year}</span>
          </span>
        </div>

        <div className="event-temp-event-header__tags">
          <ul className="event-temp-event-header__badges event-temp-event-header__badges--meta">
            {metaBadges.map((badge, index) => (
              <li key={`${badge.text}-${index}`}>
                <span
                  className={
                    badge.variant === "outline-cyan"
                      ? "event-temp-badge event-temp-badge--outline-cyan"
                      : badge.variant === "solid-cyan"
                        ? "event-temp-badge event-temp-badge--solid-cyan"
                        : badge.variant === "solid-green"
                          ? "event-temp-badge event-temp-badge--solid-green"
                          : "event-temp-badge event-temp-badge--muted"
                  }
                >
                  {badge.text}
                </span>
              </li>
            ))}
          </ul>

          <ul className="event-temp-event-header__badges event-temp-event-header__badges--topics">
            {topicBadges.map((text, index) => (
              <li key={`${text}-${index}`}>
                <span className="event-temp-badge event-temp-badge--topic">{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
